import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { SessionStateService } from '../../core/session-state.service';

/**
 * Guard that allows access only to users with admin-like roles.
 * Redirects to '/busqueda-individual' if access is denied.
 */
export const adminGuard: CanActivateFn = () => {
    const router = inject(Router);
    const platformId = inject(PLATFORM_ID);
    const sessionState = inject(SessionStateService);

    if (isPlatformBrowser(platformId)) {
        const rol = sessionState.rol();

        // Check if role is admin-like (case insensitive): ADMINISTRATOR or AdminBackoffice
        if (rol) {
            const normalizedRole = rol.toUpperCase();
            if (
                normalizedRole === 'ADMINISTRATOR' ||
                normalizedRole === 'ADMINBACKOFFICE' ||
                normalizedRole === '2'
            ) {
                return true;
            }
        }
    }

    // Redirect to account page if not an administrator
    return router.createUrlTree(['/cuenta']);
};
